import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: 'bg-primary-500/10',
    text: 'text-primary-500',
    border: 'border-primary-500/20 hover:border-primary-500/50',
  },
  accent: {
    bg: 'bg-accent-500/10',
    text: 'text-accent-500',
    border: 'border-accent-500/20 hover:border-accent-500/50',
  },
  secondary: {
    bg: 'bg-secondary-500/10',
    text: 'text-secondary-500',
    border: 'border-secondary-500/20 hover:border-secondary-500/50',
  },
};

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/10 text-primary-500 mb-3">
            海量分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            探索你喜爱的影视类型
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            从动作大片到温馨爱情，从科幻巨制到经典动画，总有适合深夜的你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group relative p-5 md:p-6 rounded-xl border ${colors.border} bg-background-800/40 hover:bg-background-800 transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-11 h-11 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${colors.bg} mb-4 transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${cat.icon} text-xl md:text-2xl ${colors.text}`}></i>
                </div>
                <h3 className="text-foreground-100 text-base md:text-lg font-semibold mb-1">
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-xs">
                  {cat.count.toLocaleString()} 部影片
                </p>
                <div className={`absolute top-4 right-4 w-7 h-7 flex items-center justify-center rounded-full ${colors.bg} opacity-0 group-hover:opacity-100 transition-opacity`}>
                  <i className={`ri-arrow-right-line text-sm ${colors.text}`}></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}